import { EmeraldIconButton } from "@emerald-react/icon-button";
import useSurveyState from "@hooks/useSurveyState";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetSurveyQuery } from "@services/survey-core";
import {
  Accordion,
  AccordionGroup,
} from "@shared/components/accordion/Accordion";
import ShareClientControlsSection from "./ShareClientControlsSection";
import ShareNotificationsSection from "./ShareNotificationsSection";
import SharePdfSection from "./SharePdfSection";
import ShareWebLinkSection from "./ShareWebLinkSection";

interface ShareModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ShareModal = ({ isOpen, onClose }: ShareModalProps) => {
  const { survey } = useSurveyState();

  // Edits like section toggles don't refetch the survey, but the backend stamps
  // updatedOn. Refetch on open so "Last modified" and PDF status are current.
  useGetSurveyQuery(isOpen && survey?.id ? survey.id : skipToken, {
    refetchOnMountOrArgChange: true,
  });

  if (!isOpen) return null;

  return (
    <div className="bg-white p-3 flex flex-col gap-y-4 overflow-y-auto">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium" id="SC-ShareSurvey"
        >
          Share &ldquo;{survey?.name}&rdquo;
        </div>
        <EmeraldIconButton icon="close" type="Icon" onClick={onClose} />
      </div>

      {/* Copy PDF Link */}
      <SharePdfSection isOpen={isOpen} />

      {/* Web Link, Notifications & Client Controls */}
      <div className="bg-share-section border border-divider-1 flex flex-col gap-y-4 rounded p-4">
        <ShareWebLinkSection />

        <AccordionGroup className="share-accordion" allowMultiple={true}>
          <Accordion
            id="notifications"
            defaultOpen={true}
            title="Email Notifications"
          >
            <ShareNotificationsSection />
          </Accordion>

          <Accordion
            id="client-controls"
            defaultOpen={true}
            title="Client Interaction Controls"
          >
            <ShareClientControlsSection />
          </Accordion>
        </AccordionGroup>
      </div>
    </div>
  );
};

export default ShareModal;
